import { render, staticRenderFns } from "./NotificationSidebar.vue?vue&type=template&id=697fda59"
import script from "./NotificationSidebar.vue?vue&type=script&lang=js"
export * from "./NotificationSidebar.vue?vue&type=script&lang=js"
import style0 from "./NotificationSidebar.vue?vue&type=style&index=0&id=697fda59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports